import axios, { AxiosError, AxiosInstance } from 'axios';

import * as tokenService from '@/services/token';
import { API_V4_BASE_URL, BUILD_NUMBER, tokenKeysName } from '@/settings';

let refreshPromise: Promise<string> | null = null;

export const getRefreshToken = async () => {
  if (refreshPromise) return refreshPromise;
  refreshPromise = new Promise(async (resolve, reject) => {
    try {
      const refreshToken = localStorage.getItem(tokenKeysName.refreshToken);
      const currentToken = localStorage.getItem(tokenKeysName.token);
      const response = await instanceRefreshToken.request({
        url: '/oauth/refresh',
        withCredentials: true,
        baseURL: API_V4_BASE_URL,
        method: 'post',
        headers: {
          RefreshToken: refreshToken,
          Authorization: `Bearer ${currentToken}`,
          FrontVersion: BUILD_NUMBER || 'local'
        },
        params: {
          startWhen: 'requestFailed'
        }
      });

      const token = response.data?.data?.token.replace('Bearer ', '') || 'invalid';
      tokenService.updateToken(token);
      resolve(token);
    } catch (err) {
      const axiosError = err as AxiosError;
      console.log('axiosError', axiosError);

      if (axiosError?.isAxiosError) {
        const codesLogout = [401, 403, 404];
        codesLogout.includes(axiosError?.response?.status) && tokenService.logout();
      }

      reject(err);
    } finally {
      refreshPromise = null;
    }
  });
  return refreshPromise;
};

const instanceRefreshToken: AxiosInstance = axios.create();
